import { render, staticRenderFns } from "./Tower.vue?vue&type=template&id=0c896b3f&"
import script from "./Tower.vue?vue&type=script&lang=js&"
export * from "./Tower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports